export enum EstadoTelemedicion {
    EnServicio,
    FueraServicio,
    NoAplica
}